<template>
  <div class="row">
    <div class="table-cell col-1">{{ currentPenthouse.tower}}</div>
    <div class="table-cell col-1 bigger-text">{{ currentPenthouse.pentNumber}}</div>
    <div class="table-cell col-1 bigger-text">{{ currentPenthouse.area}}</div>
    <div class="table-cell col-2">{{ currentPenthouse.views[0]}},<br>{{ currentPenthouse.views[1]}}</div>
    <div class="table-cell col-3 bigger-text">{{ currentPenthouse.priceForMeter}}</div>
    <div class="table-cell col-4 bigger-text">{{ currentPenthouse.priceFull}}</div>
    <div class="table-cell col-5">Подробнее</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
  export default {
    name: "FilterRow",
    props: {
      penthouse: Object
    },
    computed: {
      ...mapState(['statusesAndPrices']),
      currentPenthouse() {
        return {
          tower: this.penthouse.tower,
          pentNumber: this.penthouse.pentNumber,
          area: this.penthouse.area,
          views: this.penthouse.views,
          priceForMeter: this.statusesAndPrices.content && this.statusesAndPrices.content.find(item => item.pentNumber === this.penthouse.pentNumber).priceForMeter,
          priceFull: this.statusesAndPrices.content && this.statusesAndPrices.content.find(item => item.pentNumber === this.penthouse.pentNumber).priceFull
        }
      }
    },
    mounted() {
      console.log('STA ', this.statusesAndPrices)
    }
  }
</script>

<style scoped lang="stylus">
  @import '../styles/tools'
  .row
    display flex
    flex-direction row
    justify-content flex-start
    align-items center
    min-height 60px
    width 100%
    @media (min-width 1200px)
      padding 20px 0

  .table-cell
    font-family Roboto,Arial,Helvetica,sans-serif
    font-size 5px
    letter-spacing .5px
    line-height 1.5
    color $textBlue
    text-transform uppercase
    @media (min-width: 320px) and (max-width 768px)
      width-between-property 'font-size' 320 5 768 9 true true
    @media (min-width: 768px) and (max-width 1199px)
      width-between-property 'font-size' 768 9 1199 11 true true
    @media (min-width 1200px)
      font-size 11px
      width-between-property 'font-size' 1200 9 1920 11 true true

  .bigger-text
    font-size 6px
    @media (min-width: 320px) and (max-width 768px)
      width-between-property 'font-size' 320 6 768 11 true true
    @media (min-width: 768px) and (max-width 1199px)
      width-between-property 'font-size' 768 11 1199 14 true true
    @media (min-width 1200px)
      width-between-property 'font-size' 1200 11 1920 18 true true
</style>